import { Check, X } from "lucide-react";
import { PASSWORD_RULES } from "../lib/passwordPolicy";

export const PasswordRules = ({ password, testId = "password-rules" }) => (
  <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1" data-testid={testId}>
    {PASSWORD_RULES.map((r) => {
      const ok = r.test(password || "");
      return (
        <li key={r.key} className={`flex items-center gap-1.5 text-xs ${ok ? "text-[#059669]" : "text-[#64748B]"}`} data-testid={`${testId}-${r.key}-${ok ? "ok" : "missing"}`}>
          {ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5 text-[#CBD5E1]" />}{r.label}
        </li>
      );
    })}
  </ul>
);

export default PasswordRules;
